import { GapManagementDashboardService } from "@app/projects/network-assessment/gap-management-dashboard/gapManagementDashboardService";
import { GmdWidgetProps } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdWidgetProps";
import { MetricsStackedBarLite } from "@app/shared/metrics/MetricsStackedBarLite";
import { QESWidget, QESWidgetHeader, QESWidgetTitle, QESWidgetContent } from "@app/shared/widget";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo, useRef } from "react";

export const GapOverviewWidget: FC<GmdWidgetProps> = ({ errorBanner, loadingIcon }) => {
  const gapManagementDashboardService = useRef(new GapManagementDashboardService()).current;

  const { data: gapOverviewData, isError, isLoading } = useQuery({
    enabled: true,
    queryFn: ({ signal }) => gapManagementDashboardService.getGapOverviewData(signal),
    queryKey: ["gmd-gap-overview"],
  });

  const totalGaps = useMemo(() => {
    return gapOverviewData?.barData?.segments.reduce((total, value) => total += value.numberValue, 0) || 0;
  }, [gapOverviewData]);

  return (
    <QESWidget className="gap-management-dashboard__widget">
      <QESWidgetHeader>
        <QESWidgetTitle>Gap Overview</QESWidgetTitle>
      </QESWidgetHeader>
      <QESWidgetContent>
        {isLoading ? loadingIcon :
          isError ? errorBanner : (
            <>
              <span className="gap-management-dashboard__gap-overview-highlight">{totalGaps?.toLocaleString()}</span> <span>gaps</span>
              <MetricsStackedBarLite
                {...gapOverviewData?.barData}
                showLegend
              />
              <hr />
              <div className="gap-management-dashboard__gap-overview-row">
                <span className="gap-management-dashboard__vertical-value">
                  <span className="gap-management-dashboard__vertical-value-top">{gapOverviewData?.members.toLocaleString()}</span>
                  <span className="gap-management-dashboard__vertical-value-bottom">members</span>
                </span>
                <span className="gap-management-dashboard__vertical-value">
                  <span className="gap-management-dashboard__vertical-value-top">{gapOverviewData?.exceptions.toLocaleString()}</span>
                  <span className="gap-management-dashboard__vertical-value-bottom">exceptions</span>
                </span>
                <span className="gap-management-dashboard__vertical-value">
                  <span className="gap-management-dashboard__vertical-value-top">{gapOverviewData?.newGaps.toLocaleString()}</span>
                  <span className="gap-management-dashboard__vertical-value-bottom">new gaps</span>
                </span>
              </div>
            </>
          )}
      </QESWidgetContent>
    </QESWidget>
  );
}